const PageError = ({
  status,
  message,
  action,
}: {
  status: number;
  message: string;
  action?: React.ReactNode;
}) => {
  const numberStr = status.toString();
  const middleIndex = Math.floor(numberStr.length / 2);

  const beforeMiddle = numberStr.slice(0, middleIndex);
  const middle = numberStr[middleIndex];
  const afterMiddle = numberStr.slice(middleIndex + 1);

  return (
    <div className="text-[#2B0C1A] full text-center flex items-center h-screen w-full justify-center flex-col">
      <h1 className="text-[96px]">
        {beforeMiddle}
        <span style={{ color: "#F5CB2B" }}>{middle}</span>
        {afterMiddle}
      </h1>
      <p className="font-semibold text-[21px]">{message}</p>
      <div>
        <img src="/404.webp" alt="404" className="w-[800px]" />
      </div>
      <div className="flex gap-4 mt-8 justify-center">
        <button
          className="px-6 py-2 rounded bg-[#F5CB2B] text-[#2B0C1A] font-semibold hover:bg-[#e6bc1a] transition"
          onClick={() => window.location.href = "/"}
        >
          Voltar para Home
        </button>
        <button
          className="px-6 py-2 rounded bg-[#2B0C1A] text-white font-semibold hover:bg-[#1a0710] transition"
          onClick={() => window.location.reload()}
        >
          Atualizar Página
        </button>
        {action}
      </div>
    </div>
  );
};

export default PageError;
